import {Component, ElementRef, EventEmitter, Input, Output} from '@angular/core';
import {SafeHtml} from '@angular/platform-browser';
import {TranslateService} from '@ngx-translate/core';
import {finalize} from 'rxjs/operators';

import {Destroyable} from '../../../destroyable.component';
import {Contract, EmpFile} from '../../employees/employees.model';
import {EmployeesService} from '../../employees/employees.service';
import {FieldRegistry} from '../../form-generator/fields/registry';
import {GroupZoneDescriptor, Value, ZoneDescriptor} from '../../form-generator/form-generator.interfaces';
import {Card} from '../contract-data.interfaces';
import {ProfileMode} from '../../../app.constants';

@Component({
  selector: 'gp-contract-data-card',
  templateUrl: './contract-data-card.component.html',
  styleUrls: ['./contract-data-card.component.scss']
})
export class ContractDataCardComponent extends Destroyable {

  // todo: type
  @Input() public card: Card;
  @Input() public isMultipleCardType: boolean;
  @Input() public isInactiveContract: boolean;
  @Input() public contracts: Array<Contract>;
  @Input() public activeGroupZone: GroupZoneDescriptor;
  @Input() public profileMode?: ProfileMode;
  @Output() public edit = new EventEmitter<Card>();
  public downloading: boolean;

  constructor(
    private translate: TranslateService,
    private registry: FieldRegistry,
    private elementRef: ElementRef,
    private employeesService: EmployeesService
  ) {
    super();
  }

  public displayValue(value: Value, descriptor: ZoneDescriptor): SafeHtml {
    if (descriptor.type === 'CONTRACT') {
      return this.registry.getDisplayValue(value, descriptor, null, this.contracts);
    }
    return this.registry.getDisplayValue(value, descriptor);
  }

  public downloadFile(event: any, file: EmpFile): void {
    event.stopImmediatePropagation();

    this.downloading = true;
    this.employeesService.downloadFile(file, '', true, this.profileMode || ProfileMode.CLASSIC)
      .pipe(finalize(() => this.downloading = false))
      .subscribe();
  }

  public editCard() {
    this.edit.emit(this.card);
  }
}
